import { createContext, ReactNode, useContext } from "react"
import { remote as defaultRemote, store as defaultStore, getRemoteId as defaultGetRemoteId, isNew as defaultIsNew } from 'lib/DataModel'
import { JSONAPISource } from '@orbit/jsonapi'
import { MemorySource } from '@orbit/memory'
import { InitializedRecord } from "@orbit/records"

export type GetRemoteIdFn = (resource: InitializedRecord) => string | null | undefined
export type IsNewFn = (resource: InitializedRecord) => boolean

type Orbit = {
  remote : JSONAPISource
  store : MemorySource
  getRemoteId: GetRemoteIdFn
  isNew: IsNewFn
}

interface OrbitProviderProps {
  orbit?: Orbit
  children?: ReactNode
}

const defaultOrbit = { remote: defaultRemote, store: defaultStore, getRemoteId: defaultGetRemoteId, isNew: defaultIsNew }
const OrbitContext = createContext<Orbit>(defaultOrbit)

export default function OrbitProvider({ orbit = defaultOrbit, children }: OrbitProviderProps) {
  return (
    <OrbitContext.Provider value={orbit}>
      {children}
    </OrbitContext.Provider>
  )
}

export function useOrbit(): Orbit {
  return useContext(OrbitContext)
}
